import { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function DailyPointsSummaryTable() {

  const navigate = useNavigate();
  const [rows] = useState([
    {
      id: 1,
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      total: 1200,
      earned: 300,
      redeemed: 150,
      inProcess: 50,
      expired: 20,
    },
    {
      id: 2,
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      total: 850,
      earned: 200,
      redeemed: 100,
      inProcess: 25,
      expired: 10,
    },
    {
      id: 3,
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      total: 600,
      earned: 150,
      redeemed: 50,
      inProcess: 30,
      expired: 5,
    },
  ]);

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow hover>
              <TableCell>User</TableCell>
              <TableCell>Total Loyalty Points</TableCell>
              <TableCell>Earned Points</TableCell>
              <TableCell>Redeemed Points</TableCell>
              <TableCell>In-Process Points</TableCell>
              <TableCell>Expired Points</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow hover key={row.id}>
                <TableCell>
                  <Box
                    component="a"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/manage-users/detail");
                    }}
                    className="user_block click_action"
                  >
                    <p>
                      <b>{row.name}</b>
                      <span>{row.email}</span>
                      <span>{row.phone}</span>
                    </p>
                  </Box>
                </TableCell>
                <TableCell>{row.total}</TableCell>
                <TableCell className="c_success">{row.earned}</TableCell>
                <TableCell className="c_warning">{row.redeemed}</TableCell>
                <TableCell className="c_info">{row.inProcess}</TableCell>
                <TableCell className="c_danger">{row.expired}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
